/* eslint-disable import/prefer-default-export */
import { graphql } from 'graphql-schema';

export const CURRENT_USER_CANCEL_DROP_IN = graphql(`
  mutation CurrentUserCancelDropIn($dropInSlotId: uuid!) {
    currentUserCancelDropIn(drop_in_slot: $dropInSlotId) {
      drop_in_slot
    }
  }
`);
